export { default as BlueLogo } from './cropped.svg';
